export const SECTION_TYPES = [
  { value: 'description', label: 'Description', icon: 'fas fa-align-left' },
  { value: 'video', label: 'Video tutorial', icon: 'fas fa-play-circle' },
  { value: 'steps', label: 'Install steps', icon: 'fas fa-list-ol' },
  { value: 'platformVideos', label: 'Platform videos', icon: 'fas fa-th-large' },
  { value: 'cta', label: 'Call to action', icon: 'fas fa-hand-pointer' },
  { value: 'faq', label: 'FAQ', icon: 'fas fa-question-circle' },
  { value: 'importString', label: 'Import string', icon: 'fas fa-clipboard' },
  { value: 'commands', label: 'Commands', icon: 'fas fa-terminal' },
];

export function getSectionTypeMeta(type) {
  return SECTION_TYPES.find((t) => t.value === type) || { value: type, label: type, icon: 'fas fa-cube' };
}

export function getSectionSummary(section) {
  const meta = getSectionTypeMeta(section.type);
  const title = [section.heading, section.highlight].filter(Boolean).join(' ');
  if (title) return title;
  if (section.type === 'steps') return `${meta.label} (${(section.steps || []).length} steps)`;
  if (section.type === 'faq') return `${meta.label} (${(section.items || []).length} items)`;
  if (section.type === 'commands') return `${meta.label} (${(section.commands || []).length} commands)`;
  return meta.label;
}

export function defaultSection(type) {
  switch (type) {
    case 'description':
      return { type, heading: 'What is', highlight: '', paragraphs: [''] };
    case 'video':
      return { type, heading: 'Video', highlight: 'Tutorial', youtubeId: '', title: '' };
    case 'steps':
      return { type, heading: 'Setup', highlight: '', intro: '', steps: [{ title: '', paragraphs: [''], images: [] }] };
    case 'platformVideos':
      return { type, heading: 'Platform', highlight: 'Tutorials', intro: '', platforms: [{ name: '', highlight: 'Tutorial', youtubeId: '', comingSoon: false }] };
    case 'cta':
      return { type, heading: 'Ready to', highlight: 'Get Started?', buttons: [{ href: '', text: '', icon: 'fas fa-download', variant: 'primary', primary: true, download: false, external: false, style: { background: '', color: '', borderColor: '', hoverBackground: '' } }], beta: null };
    case 'faq':
      return { type, heading: 'FAQ', highlight: 'Questions', items: [{ question: '', answer: '', isList: false, listItems: [] }] };
    case 'importString':
      return {
        type,
        heading: 'Streamer.bot',
        highlight: 'Import String',
        intro: 'Click the bar below to copy the Streamer.bot import string to your clipboard.',
        importString: '',
        copiedLabel: 'Copied!',
        helpText: 'Paste into Streamer.bot via Import → Import String.',
      };
    case 'commands':
      return {
        type,
        heading: 'Chat',
        highlight: 'Commands',
        intro: '',
        collapsible: true,
        defaultOpen: true,
        panelTitle: 'Commands',
        commands: [
          {
            command: '!lurk',
            permission: 'EVERYONE',
            description: 'Start lurking and begin tracking your lurk time.',
            example: '!lurk',
          },
        ],
      };
    default:
      return { type: 'description', heading: '', highlight: '', paragraphs: [] };
  }
}

export const emptyPage = () => ({
  slug: '',
  title: '',
  seo: { description: '', keywords: '', url: '' },
  hero: { title: '', highlight: '', subtitle: '', image: '' },
  content: { sections: [] },
  published: true,
  sortOrder: 0,
});
